module.exports = __webpack_public_path__ + "resources/img/bg-news-top@2x.801599c8.jpg";